export const API_ACCESS_TOKEN = '_BzVjAx3LwE32jwClHzF';
export const API_BASE_URL = 'https://the-one-api.dev/v2';
export const STALE_TIME = 10 * 60 * 1000; // 10 minutes
